import { useTranslation } from '../../../utils/useTranslation';
import { IconArrowLeft } from '../../icon/IconArrowLeft';
import { Button } from '../../input/Button';
import { IconButton } from '../../input/IconButton';
import { Flex } from '../../layout/Flex';
import { Spin } from '../../layout/Spin/Spin';
import { Typography } from '../../typography/Typography';
import { ErrorMessage } from '../PartnerRegistrationForm/components/ErrorMessage';
import { ActionButtonWrapper } from '../PartnerRegistrationForm/styles';
import { APPROVAL_STEPS } from './constants';
import { IconContainer, StepContainer, StepText } from './styles';
import { PartnerApprovalFormProps } from './types';
import { openNalogSite } from './utils/openNalogSite';

export const PartnerApprovalPage = ({
    onSubmit,
    onResendForm,
    onBack,
    isLoading,
    errorMessage,
}: PartnerApprovalFormProps) => {
    const t = useTranslation();

    return (
        <Flex width="100%" height="100%" direction="column">
            <Flex direction="row" alignItems="center" mb={4} spacing={2}>
                <IconButton onClick={onBack} size="m" padding={0}>
                    <IconArrowLeft size={24} />
                </IconButton>
                <Typography variant="title3" weight="medium">
                    {t('Подтвердите сотрудничество')}
                </Typography>
            </Flex>

            <Flex flexGrow={1} direction="column">
                {APPROVAL_STEPS.map((step, index) => {
                    const IconComponent = step.icon;

                    return (
                        <StepContainer key={index}>
                            <IconContainer>
                                <IconComponent size={24} color="var(--color-primary)" />
                            </IconContainer>
                            <StepText>{t(step.text)}</StepText>
                        </StepContainer>
                    );
                })}
            </Flex>

            <ActionButtonWrapper>
                <Button width="100%" color="primary" size="l" onClick={onSubmit} mb={1.5}>
                    {isLoading ? <Spin color="var(--color-invert)" size={20} /> : t('Далее')}
                </Button>
                <Button
                    width="100%"
                    color="secondary"
                    size="l"
                    onClick={onResendForm}
                    variant="outlined"
                    mb={1.5}
                >
                    {t('Отправить форму заново')}
                </Button>
                <Button
                    width="100%"
                    color="secondary"
                    size="l"
                    onClick={openNalogSite}
                    variant="outlined"
                >
                    {t('Перейти в «Мой налог»')}
                </Button>
                <ErrorMessage message={errorMessage} />
            </ActionButtonWrapper>
        </Flex>
    );
};
